import { UseMutationOptions } from '@tanstack/react-query';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';
import MutationKeys from './keys';

export type MigrationSource = 'salesforce';

export type ParseMigrateTemplateInput = {
    htmlContent: string;
    source: MigrationSource;
};

export type ConditionExpressionItem = {
    id: string;
    expression: string;
    isElse: boolean;
    precedingExpressions: string[];
    humanReadable: string;
};

export type ParseMigrateTemplateResponse = {
    personalizationTags: string[];
    conditionExpressions: ConditionExpressionItem[];
    conditionFields: string[];
    savedTagMappings: Record<string, string>;
    savedConditionFieldMappings: Record<string, string>;
};

const useParseMigrateTemplate = (
    mutateOptions?: UseMutationOptions<ParseMigrateTemplateResponse, Error, ParseMigrateTemplateInput>
) =>
    useMutation<ParseMigrateTemplateInput, ParseMigrateTemplateResponse>(
        MutationKeys.PARSE_MIGRATE_TEMPLATE,
        CuredApiPaths.TEMPLATES_MIGRATE_PARSE,
        mutateOptions
    );

export default useParseMigrateTemplate;
